
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preorder/payment/[[...step]]",
      function () {
        return require("private-next-pages/preorder/payment/[[...step]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preorder/payment/[[...step]]"])
      });
    }
  